"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template3BusinessFeature = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-3-business-feature.scss");

var check_svg_1 = __importDefault(require("./check.svg"));

function Template3BusinessFeature(_ref) {
  var items = _ref.items,
      className = _ref.className;
  return items.length > 0 ? react_1.default.createElement("div", {
    className: "".concat(className.wrapper)
  }, items.map(function (item, index) {
    return react_1.default.createElement("div", {
      key: index,
      className: "flex ".concat(className.item)
    }, react_1.default.createElement("img", {
      src: check_svg_1.default,
      alt: "",
      className: className.icon
    }), item.name);
  })) : react_1.default.createElement(react_1.default.Fragment, null);
}

exports.Template3BusinessFeature = Template3BusinessFeature;
Template3BusinessFeature.propTypes = {
  className: prop_types_1.default.object
};
Template3BusinessFeature.defaultProps = {
  items: [],
  className: {
    wrapper: 'flex w-full relative flex-wrap',
    icon: 'mr-19px',
    item: 'w-full lg:w-1/2 mb-20px'
  }
};